/* eslint-disable no-lone-blocks */
import axios from 'axios';
import { apiPostHeader, currentCompanyId, currentprojectid, multipartPartFormDataHeader, simpleHeader, tokenGetter } from '../utils/axios';
import { baseURL, baseURLStaging } from '../config-global';
import { enqueueSnackbar } from "notistack";
import { handleErrorMessages } from './fetching';

export const postRequest = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentprojectid(),
          currentCompanyId: currentCompanyId(),

        }
      });
      return response.data;
    }
    catch (error) {
      return error.response?.data

    }
  }
}
export const postRequestForWebsite = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, JSON.stringify(data), {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentprojectid(),
          currentCompanyId: currentCompanyId(),
          'Content-Type': 'application/json',

        }
      });
      return response.data;
    }
    catch (error) {
      return error.response?.data

    }
  }
}
export const postRequestProject = async (endPoint, data, isMultiPart, currentItem) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentItem,
          currentCompanyId: currentCompanyId(),

        }
      });
      return response.data;
    }
    catch (error) {
      return error.response?.data

    }
  }
}
export const postRequestStaging = async (endPoint, data, isMultiPart) => {
  {
    try {
      const response = await axios.post(`${baseURLStaging}${endPoint}`, data, {
        headers: isMultiPart ? multipartPartFormDataHeader : apiPostHeader
      });
      return response.data || response;
    }
    catch (error) {
      return error.response?.data

    }
  }
}
export const postRequestDummy = async (endPoint, data, isMultiPart, currentItem) => {
  {
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, data, {
        headers: {
          ...simpleHeader,
          //currentprojectid: currentItem
        },
      });
      return response.data;
    }
    catch (error) {
      return error.response?.data

    }
  }
}


export const getRequest = async (endPoint, isArray = true, ismessage) => {
  {
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}` || '',
          currentprojectid: currentprojectid(),
          currentCompanyId: currentCompanyId(),
        }
      });
      return ismessage === true ? response?.data : response?.data?.payload || null;
    }
    catch (error) {
      return isArray ? [] : {} || ismessage === true ? error?.response : {}
    }
  }
}

export const getRequestMessage = async (endPoint, isArray = true) => {
  try {
    const response = await axios.get(`${baseURL}${endPoint}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}` || '',
        currentprojectid: currentprojectid(),
        currentCompanyId: currentCompanyId(),
      },
    });
    // console.log("📦 Data Returned:", response?.data);
    return response?.data;
  } catch (error) {
    console.error("❌ getRequestMessage - Error:", error?.response || error);
    return isArray ? [] : {};
  }
};


export const getRequestPorject = async (endPoint, isArray = true, currentItem) => {
  {
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, {
        headers: {
          Authorization: tokenGetter(),
          currentprojectid: currentItem,
          currentCompanyId: currentCompanyId(),

        }
      });
      return response?.data?.payload || null;
    }
    catch (error) {
      return isArray ? [] : {}
    }
  }
}
export const getRequestStaging = async (endPoint, isArray = true) => {
  {
    try {
      const response = await axios.get(`${baseURLStaging}${endPoint}`, {
        headers: simpleHeader
      });
      return response?.data?.payload || null;
    }
    catch (error) {
      return isArray ? [] : {}
    }
  }
}
export const getRequestDummy = async (endPoint, id, isArray = true) => {

  {
    try {
      const response = await axios.get(`${baseURLStaging}${endPoint}`, {
        headers: {
          ...simpleHeader,
          currentProjectId: 1297
        }
      }
      );
      return response?.data?.payload || null;
    }
    catch (error) {
      return isArray ? [] : {}
    }
  }
}


export const deleteRequest = async (endPoint, callBack) => {
  {
    try {
      const response = await axios.delete(`${baseURL}${endPoint}`, {
        headers: simpleHeader
      });
      console.log("🚀 ~ deleteRequest ~ response:", response)
      if (response) {
        const myMetaData = response?.data?.metadata
        if (myMetaData.success) {
          callBack()
          enqueueSnackbar({
            variant: 'success',
            message: myMetaData.message,
          });
        } else {
          handleErrorMessages(myMetaData.message);
        }
      }
      return response?.data
    }
    catch (error) {
      console.log("🚀 ~ deleteRequest ~ error:", error)
      enqueueSnackbar({
        variant: 'error',
        message: error?.response?.data?.metadata?.message || "Something went wrong",
      });
      return error
    }
  }
}

export const deleteRequestmsg = async (endPoint) => {
  {
    try {
      const response = await axios.delete(`${baseURL}${endPoint}`, {
        headers: simpleHeader,
      });
      if (response?.data) {
        const myMetaData = response?.data?.metadata;
        const message = Array.isArray(response?.data?.payload)
          ? response?.data?.metadata?.message
          : response?.data?.payload || response?.data?.metadata?.message;
        if (myMetaData.success) {
          enqueueSnackbar({
            variant: 'success',
            message,
          });
        } else {
          handleErrorMessages(message);
        }
      }
      return response?.data;
    } catch (error) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Oops, something went wrong',
      });
      return error;
    }
  }
}
